export default __webpack_public_path__ + "static/media/line-arrow-left-outline-16px.a3514f3f.svg";